(function () {
  'use strict';
  angular.lowercase = str => angular.isString(str) ? str.toLowerCase() : str
  angular.module('MktzapApp.Directives', []);
  angular.module('MktzapApp.Factories', ['ngResource']);
  angular.module('MktzapApp', [
    'ui.router',
    'MktzapApp.Controllers',
    'MktzapApp.Directives',
    'MktzapApp.Factories',
    'unsavedChanges',
    'colorpicker.module',
    'ngTagsInput',
    'ngResource',
    'textAngular',
    'googlechart',
    'ui.mask',
    'ui.select',
    'ngSanitize',
    'angularAudioRecorder'
  ])
    .config(config)
    .run(run)
    .directive('title', title)
    .directive('nwFileChooser', uploadDiretive);

  config.$inject = ['$urlRouterProvider', '$stateProvider', '$locationProvider', '$provide', 'unsavedWarningsConfigProvider'];
  function config($urlRouterProvider, $stateProvider, $locationProvider, $provide, unsavedWarningsConfigProvider) {
    $locationProvider.hashPrefix('')
    $provide.decorator('taOptions', ['taRegisterTool', 'taTranslations', 'taToolFunctions', '$http', '$delegate', function (taRegisterTool, taTranslations, taToolFunctions, $http, taOptions) { // $delegate is the taOptions we are decorating
      taOptions.toolbar = [
        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough'],
        ['justifyLeft', 'justifyCenter', 'justifyRight', 'html', 'insertLink']
      ];
      taRegisterTool('insertImageFromS3', {
        iconclass: 'fa fa-picture-o',
        tooltiptext: taTranslations.insertImage.tooltip,
        action: function () {
          var context = this;
          var input = angular.element("<input type='file' name='file' style='display:none'>");
          input.click(); // opening dialog
          input.change(function () {
            var formData = new FormData();
            formData.append('file', input[0].files[0]);
            $http.post(baseUrl + '/signature-picture', formData,
              {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
              })
              .then(function (response) {
                var imageLink = response.url;
                if (imageLink && imageLink !== '' && imageLink !== 'https://') {
                  return context.$editor().wrapSelection('insertImage', imageLink, true);
                }
              }, function (error) { console.log(error) });
          })

          /* v */
        },
        onElementSelect: {
          element: 'img',
          action: taToolFunctions.imgOnSelectAction
        }
      });

      taRegisterTool('insertCampaignImageFromS3', {
        iconclass: 'fa fa-picture-o',
        tooltiptext: taTranslations.insertImage.tooltip,
        action: function () {
          var context = this;
          var input = angular.element("<input type='file' name='file' style='display:none'>");
          input.click(); // opening dialog
          input.change(function () {
            var formData = new FormData();
            formData.append('file', input[0].files[0]);
            $http.post(baseUrl + '/campaign-picture', formData,
              {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
              })
              .then(function (response) {
                var imageLink = response.data.url;
                if (imageLink && imageLink !== '') {
                  return context.$editor().wrapSelection('insertImage', imageLink, true);
                }
              }, function (error) { console.log(error) });
          });
        },
        onElementSelect: {
          element: 'img',
          action: taToolFunctions.imgOnSelectAction
        }
      });

      taOptions.toolbar[1].push('insertImageFromS3');
      return taOptions;
    }]);
    $provide.decorator('$state', ['$delegate', '$rootScope', function ($delegate, $rootScope) {
      $rootScope.$on('$stateChangeStart', function (event, state, params) {
        $rootScope.favicon_url = baseUrl + '/assets/images/mktzap-favicon.png';
        $delegate.next = state;
        $delegate.toParams = params;
        $rootScope.status_unread_count = {};
      });
      return $delegate;
    }]);
    unsavedWarningsConfigProvider.navigateMessage = 'ATENÇÃO! Você perderá todos os dados não salvos.';
    unsavedWarningsConfigProvider.reloadMessage = 'ATENÇÃO! Você perderá todos os dados não salvos.';

    var resolveLabels = function (pageName) {
      return ['$rootScope', function ($rootScope, LangService) {
        return $rootScope.getPageLabels(pageName);
      }]
    }

    $stateProvider
      .state('login', {
        url: frontUrl + '/login',
        data: { pageTitle: 'Login' },
        templateUrl: baseUrl + '/templates/common/login.html',
        controller: 'LoginController as vm'
      })
      .state('sesame-mktzap', {
        url: frontUrl + '/sesame-mktzap/:hash',
        data: { pageTitle: 'Acesso Sesame' },
        templateUrl: baseUrl + '/templates/common/sesame-mktzap.html',
        controller: 'SesameAccessController as vm'
      })

      .state('main', {
        templateUrl: baseUrl + '/templates/common/menu.html',
        // Make this state abstract so it can never be loaded directly
        abstract: true,
        resolve: {
          constants: ['$rootScope', function ($rootScope) {
            $rootScope.mktzapUrl = mktzapUrl
          }],
          menuLabels: ['$rootScope', 'LangService', function ($rootScope, LangService) {
            LangService
              .getPageLabels({ 'page': 'menu' })
              .$promise
              .then(function (data) {
                $rootScope.menu = {};
                $rootScope.menu.labels = data.lang;
              });
          }],

          validateHistoryMenuPermission: ['$rootScope', function($rootScope){
            $rootScope.validateHistoryMenuPermission = () => {
              if ($rootScope.company_metadata.allow && $rootScope.company_metadata['history_menu'] && $rootScope.company_metadata['history_menu'].branch == true && $rootScope.user_data.role != $rootScope.profiles.ROLE_ADMIN)  {
                if (
                  ($rootScope.company_metadata['history_menu'].user_operator && $rootScope.profiles.ROLE_OPERATOR == $rootScope.user_data.role) ||
                  ($rootScope.company_metadata['history_menu'].user_manager && $rootScope.profiles.ROLE_MANAGER == $rootScope.user_data.role) ||
                  ($rootScope.company_metadata['history_menu'].user_promoter && $rootScope.profiles.ROLE_PROMOTER == $rootScope.user_data.role) ||
                  ($rootScope.company_metadata['history_menu'].user_administrator && $rootScope.profiles.ROLE_MESSAGES_PORTAL_MANAGER == $rootScope.user_data.role) ||
                  ($rootScope.company_metadata['history_menu'].user_supervisor && $rootScope.profiles.ROLE_MESSAGES_PORTAL_SUPERVISOR == $rootScope.user_data.role)
                ) {
                    return true;
                  }
                    return false ;
              }
                return true ;
            }
          }],

          companyMetaData: ['$rootScope', 'CompanyService', function ($rootScope, CompanyService) {
            CompanyService
              .loadMetadata()
              .$promise
              .then(function (data) {
                $rootScope.company_metadata = data;
              })
              .catch(function (error) {
                $rootScope.company_metadata = [];
              });
          }],
          versionData: ['$rootScope', 'VersioningService', function ($rootScope, VersioningService) {
            VersioningService
              .getLastVersion()
              .$promise
              .then(function (data) {
                $rootScope.versioning_metadata = data;
              })
              .catch(function (error) {
                $rootScope.versioning_metadata = [];
              });
          }],

          automaticDistributionData: ['$rootScope', 'AutomaticDistributionService', 'NotificationService', function ($rootScope, AutomaticDistributionService) {
            AutomaticDistributionService.find()
              .$promise
              .then(function (data) {
                if (data) {
                  $rootScope.automatic_distribution = data
                }
              })
              .catch(function (data) {
                deferred.reject(error);
              });
          }],

          notAllowed: ['$rootScope', '$state', 'ControlPauseService', 'LocalStorageService', function ($rootScope, $state, ControlPauseService, LocalStorageService) {
            $rootScope.$on('send_to_blockpage', function (data) {
              $rootScope.blockPage(data);
            });
            $rootScope.blockPage = function (newValue) {
              if (LocalStorageService.checkInPause()) {
                if ($state.next.name != 'main.user-in-pause') {
                  if ($rootScope.user_data) {
                    if ($rootScope.user_data.session_user) {
                      $rootScope.user_data.session_user.is_paused = true;
                      $rootScope.user_data.operator_status = false;
                    }
                  }
                  LocalStorageService.sendToBlockPage();
                }
              }
            };
          }],

          TriageModes: ['$rootScope', function ($rootScope) {
            $rootScope.parseTriageName = function (profile) {
              switch (profile) {
                case '0': return 'Modo Básico';
                case '1': return 'Modo Gestor';
                case '2': return 'Modo Operador';
                case '3': return 'Modo Promotor';
                case '4': return 'Modo Gerente do Portal de Envio';
                case '5': return 'Modo Supervisor do Portal de Envio';
              }
            }
            $rootScope.TriageModes = {
              BASIC: '0',
              MANAGER: '1',
              OPERATOR: '2',
              PROMOTER: '3',
              MESSAGES_PORTAL_MANAGER: '4',
              MESSAGES_PORTAL_SUPERVISOR: '5'
            }
            return $rootScope.TriageModes;
          }],
          profiles: ['$rootScope', 'PollService', function ($rootScope, PollService) {
            PollService.all()
              .$promise
              .then(function (data) {
                $rootScope.polls = data;
              })
              .catch(function (data) {
                $rootScope.polls = [];
                // errorHandler(data,"Erro ao carregar Pesquisa de Satisfação.")
              })
            $rootScope.getProfileTitle = function (profile) {
              var pro = parseInt(profile + '');
              switch (pro) {
                case 0: return 'Operador';
                case 1: return 'Gestor';
                case 2: return 'Promotor';
                case 3: return 'Gerente';
                case 4: return 'Supervisor';
                case 1000: return 'Lord of the Castle';
              }
            }
            $rootScope.profiles = {
              ROLE_OPERATOR: 0,
              ROLE_MANAGER: 1,
              ROLE_PROMOTER: 2,
              ROLE_MESSAGES_PORTAL_MANAGER: 3,
              ROLE_MESSAGES_PORTAL_SUPERVISOR: 4,
              ROLE_ADMIN: 1000
            }
            return $rootScope.profiles;
          }],
          user_data: ['$http', '$rootScope', 'AuthenticationService', '$q', '$state', 'socketConnect', '$location', 'StatusService', 'UserService', 'LocalStorageService', 'NotificationService', 'SMSService', 'LocalizationService', function ($http, $rootScope, AuthenticationService, $q, $state, socketConnect, $location, StatusService, UserService, LocalStorageService, NotificationService, SMSService, LocalizationService) {
            // @Todo: load routes
            const USER_IN_PAUSE_ERROR_CODE = '0001'

            if (!AuthenticationService.haveCredentials()) {
              var deferred = $q.defer();
              var promise = deferred.promise;

              promise.catch(function () {
                $state.go('login');
              });

              deferred.reject();

              return promise;
            }

            $rootScope.canSeePaidStatus = function (statusId) {
              $rootScope.checkMenuAccess('att');
              return (statusId !== $rootScope.paidStatus && statusId !== $rootScope.willPayStatus) || $rootScope.user_data.role == $rootScope.profiles.ROLE_MANAGER || $rootScope.user_data.role == $rootScope.profiles.ROLE_ADMIN;
            };

            $rootScope.changeOperatorStatus = function (new_status) {
              $http.post(apiUrl + '/change-status', { status: new_status })
                .then(function (data) {
                  $rootScope.user_data.operator_status = new_status;
                }, function (error) { console.log(error) });
            };

            $rootScope.$on('illegal_token', function (data) {
              NotificationService.errorHandler(data, 'Você foi desconectado, é necessário realizar o login novamente.');
            });

            function rejection() {
              $location.path(loginUrl);
              $rootScope.$broadcast('illegal_token', 'Usuário desconectado!');
            }

            function socketSetSession() {
              socketConnect.emit('set_session', {
                id: $rootScope.user_data.id,
                role: $rootScope.user_data.role,
                company_id: $rootScope.user_data.company_id
              });
            }

            var promises = [];
            promises.push(StatusService.menu_statuses().$promise);
            promises.push(UserService.getSockeToken().$promise);
            promises.push(SMSService.sms_message_status().$promise);
            promises.push(LocalizationService.getTimezone().$promise);
            var deferred = $q.defer();

            UserService
              .user_data()
              .$promise
              .then(function (user) {
                $rootScope.user_data = user;
                if ($rootScope.user_data.change_password == 1) {
                  $rootScope.changepassword = 1;
                  $location.path(loginUrl);
                }

                $q.all(promises)
                  .then(function (datas) {
                    // classification-statuses
                    $rootScope.classification_statuses = datas[0];
                    $rootScope.sms_message_status = datas[2];

                    // company-metadata
                    if ($rootScope.company_metadata.hasOwnProperty('classification') && $rootScope.company_metadata.classification.enabled === true && $rootScope.company_metadata.classification.will_pay_status > 0) {
                      $rootScope.willPayStatus = $rootScope.company_metadata.classification.will_pay_status;
                    }
                    if ($rootScope.company_metadata.hasOwnProperty('classification') && $rootScope.company_metadata.classification.enabled === true && $rootScope.company_metadata.classification.paid_status > 0) {
                      $rootScope.paidStatus = $rootScope.company_metadata.classification.paid_status;
                    }

                    // localization
                    $rootScope.locale = {};
                    $rootScope.locale.timezone = 'America/Sao_Paulo';
                    if (datas[3] && datas[3].hasOwnProperty('timezone')) {
                      $rootScope.locale.timezone = datas[3].timezone;
                    }

                    var socketToken = datas[1];

                    if ($rootScope.user_data.session_user) {
                      var ModelFactory = { is_paused: $rootScope.user_data.session_user.is_paused, start_pause_at: $rootScope.user_data.session_user.start_pause_at };
                      if ($rootScope.user_data.session_user.hasOwnProperty('auto_logout_at') && $rootScope.user_data.session_user.auto_logout_at != null) {
                        ModelFactory.auto_logout_at = $rootScope.user_data.session_user.auto_logout_at;
                      }
                      LocalStorageService.saveUserPauseState(ModelFactory);
                      $rootScope.$broadcast('send_to_blockpage');
                    }

                    if (socketToken.hasOwnProperty('token') && socketToken.token) {
                      socketConnect.connect(socketSessionUrl);
                      socketConnect.on('persist_socket', function (socketid) {
                        $rootScope.socket = socketid;
                      });

                      socketConnect.on('get_session', function (result) {
                        socketSetSession();
                      });
                      socketConnect.emit('authenticate', socketToken.token);
                      socketSetSession();
                    }
                    deferred.resolve($rootScope.user_data);
                  }).catch(function (e) {
                    if (e.data.status_code == USER_IN_PAUSE_ERROR_CODE) {
                      LocalStorageService.saveUserPauseState({ is_paused: true });
                      deferred.resolve($rootScope.user_data)
                    } else {
                      deferred.reject(e)
                    }
                  });
              })
              .catch(rejection);
            return deferred.promise;
          }],
          auth: ['$q', 'user_data', '$state', 'profiles', '$rootScope', function ($q, user, $state, profiles, $rootScope) {
            var user_data = user;
            var deferred = $q.defer();
            var promise = deferred.promise;
            var role = $state.next.data.role || 0;
            var permission = $state.next.data.permission || true;

            promise.catch(function () {
              if ($rootScope.checkMenuAccess('attendances.noClassification')) {
                $state.go('main.chat');
              } else if ($rootScope.checkMenuAccess('settings.generalSettings.messagesPortal')) {
                $state.go('main.messages-portal-send');
              } else {
                $state.go('my-account');
              }
            });

            if (permission === true || $rootScope.checkMenuAccess(permission)) {
              deferred.resolve();
            } else {
              deferred.reject();
            }

            return promise;
          }]
        }
      })
      /* Front */
      .state('main.chat', {
        url: frontUrl + '/atendimento',
        data: { pageTitle: 'Atendimento', isAtendimento: true, role: 0, permission: 'attendances.noClassification' },
        templateUrl: baseUrl + '/templates/atendimento/atendimento.html',
        controller: 'ChatController as vm',
        resolve: {
          labels: resolveLabels('menu.att.all')
        }
      })
      .state('main.history', {
        url: frontUrl + '/history',
        data: { pageTitle: 'Histórico', role: 0, page: 'history', permission: 'attendances.history' },
        templateUrl: baseUrl + '/templates/history/history.html',
        controller: 'HistoryController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.att.history');
          }]
        }
      })
      .state('main.triggers', {
        url: frontUrl + '/triggers/{type}/{id}',
         data: { pageTitle: 'Gatilhos', role: 0 },
        templateUrl: baseUrl + '/templates/triggers/triggers.html',
        controller: 'TriggersController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.channels.triggers');
          }]
        }
      })
      .state('main.my-account', {
        url: frontUrl + '/my-account',
        data: { pageTitle: 'Minha Conta', role: 0 },
        templateUrl: baseUrl + '/templates/settings/my-account.html',
        controller: 'AccountController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.config.myAccount');
          }]
        }
      })
      .state('main.multicanalidade', {
        url: frontUrl + '/multicanalidade',
        data: { pageTitle: 'Multicanalidade', role: 0, permission: 'channel.multicanalidade' },
        templateUrl: baseUrl + '/templates/multicanalidade/multicanalidade.html',
        controller: 'MultichannelLinksController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.channel.multichannel');
          }]
        }
      })
      .state('main.create-multichannel', {
        url: frontUrl + '/create-multichannel/:id?',
        data: { pageTitle: 'Link Multicanal', role: 0 },
        templateUrl: baseUrl + '/templates/multicanalidade/create-multichannel.html',
        controller: 'MultichannelLinksController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.channel.multichannel');
          }]
        }
      })
      .state('main.training', {
        url: frontUrl + '/training',
        data: { pageTitle: 'Treinamento', role: 0 },
        templateUrl: baseUrl + '/templates/training/training.html'
        // , controller: "AccountController as vm"
      })
      .state('main.triggers_status', {
        url: frontUrl + '/status',
        data: { pageTitle: 'Status Atendimento', role: 0, permission: 'attendanceRule.status' },
        templateUrl: baseUrl + '/templates/status/status.html',
        controller: 'StatusController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.busRules.attStatus');
          }]
        }
      })
      .state('main.dashboard', {
        url: frontUrl + '/dashboard',
        data: { pageTitle: 'Dashboard', role: 0 },
        templateUrl: baseUrl + '/templates/dashboard/dashboard_layout.html',
        controller: 'DashboardController as vm'
      })
      .state('main.dashboard-business-management', {
        url: frontUrl + '/dashboard/dashboard-business-management',
        data: { pageTitle: 'Dashboard Gestão de Negócio', role: 0, permission: 'dashboard.businessManagement' },
        templateUrl: baseUrl + '/allowed-settings/dashboard/business_management.html',
        controller: 'BusinessManagementController as vmBManCtrl',
        params: {
          time: null,
          business: null,
          team: null,
          op: null,
          from: null,
          to: null
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.dash.negocManag');
          }]
        }
      })
      .state('main.dashboard-team-management', {
        url: frontUrl + '/dashboard/dashboard-team-management',
        data: { pageTitle: 'Dashboard Gestão de Equipe', role: 0, permission: 'dashboard.teamManagement' },
        templateUrl: baseUrl + '/allowed-settings/dashboard/team_management.html',
        controller: 'TeamManagementController as vmTeamCtrl',
        params: {
          time: null,
          business: null,
          team: null,
          op: null,
          from: null,
          to: null
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.dash.teamManag');
          }]
        }
      })
      .state('main.dashboard-operational-summary', {
        url: frontUrl + '/dashboard/dashboard-operational-summary',
        data: { pageTitle: 'Dashboard Resumo Operacional', role: 0, permission: 'dashboard.operationalSummary' },
        templateUrl: baseUrl + '/allowed-settings/dashboard/operational_summary.html',
        controller: 'OpSummaryController as vmOPCtrl',
        params: {
          time: null,
          business: null,
          team: null,
          op: null,
          from: null,
          to: null
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.dash.opeResume');
          }]
        }
      })
      .state('main.dashboard-rotation', {
        url: frontUrl + '/dashboard/dashboard-rotation',
        data: { pageTitle: 'Rotação dos Dashboards', role: 0, permission: 'dashboard.dashboardRotation' },
        templateUrl: baseUrl + '/allowed-settings/dashboard/dashboard_rotation.html',
        controller: 'DashboardRotationController as vmDashRot',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.dash.rotation');
          }]
        }
      })
      .state('main.dashboard-metabase', {
        url: frontUrl + '/dashboard/metabase/{dash}',
        data: { pageTitle: 'Dashboard Metabase', role: 0 },
        templateUrl: baseUrl + '/allowed-settings/dashboard/metabase.html',
        controller: 'MetabaseController as vmDashMetabase',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('common');
          }]
        }
      })
      .state('main.distribution-monitoring', {
        url: frontUrl + '/dashboard/distribution-monitoring',
        data: { pageTitle: 'Dashboard Distribuição', role: 0, permission: 'dashboard.distributionMonitoring' },
        templateUrl: baseUrl + '/allowed-settings/dashboard/distribution_monitoring.html',
        controller: 'DistributionMonitoringController as vmDistributionMonitoringCtrl'
      })
      .state('main.triagem', {
        url: frontUrl + '/triagem',
        data: { pageTitle: 'Modos de Triagem', role: 0, permission: 'attendanceRule.triage' },
        templateUrl: baseUrl + '/templates/triagem/triagem.html',
        controller: 'TriagemController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.busRules.screening');
          }]
        }
      })
      /* Admin */
      .state('main.office-hours', {
        url: frontUrl + '/office-hours',
        data: { pageTitle: 'Horários de atendimento', role: 0, permission: 'master.officeHours' },
        templateUrl: baseUrl + '/templates/office-hours/office-hours.html',
        controller: 'OfficeHoursController as vm'
      })
      .state('main.versioning', {
        url: frontUrl + '/versioning',
        data: { pageTitle: 'Versionamento', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/versioning/versioning.html',
        controller: 'VersioningController as vm'
      })
      .state('main.show-versionings', {
        url: frontUrl + '/show-versionings',
        data: { pageTitle: 'Versionamentos', role: 1000 },
        templateUrl: baseUrl + '/templates/show-versionings/show-versionings.html',
        controller: 'ShowVersioningsController as vm'
      })
      .state('main.interactive', {
        url: frontUrl + '/interactive',
        data: { pageTitle: 'Interativo', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/interactive/interactive.html',
        controller: 'InteractiveController as vm'
      })
      .state('main.interactive-channel', {
        url: frontUrl + '/interactive/{id}',
        data: { pageTitle: 'Interativo', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/interactive/interactive.html',
        controller: 'InteractiveController as vm'
      })
      .state('main.reports', {})
      .state('main.reports.dashboard', {
        url: frontUrl + '/reports',
        data: { pageTitle: 'Relatórios', role: 0 },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/dashboard.html',
            controller: 'ReportsDashboardController as vm'
          }
        }
      })
      .state('main.reports.every_hour', {
        url: frontUrl + '/reports/every-hour',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.everyHour' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/every_hour.html',
            controller: 'ReportsEveryHourController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.hour');
          }]
        }
      })
      .state('main.reports.polls', {
        url: frontUrl + '/reports/polls',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.polls' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/polls.html',
            controller: 'ReportsPollsController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.poll');
          }]
        }
      })
      .state('main.reports.complete', {
        url: frontUrl + '/reports/complete',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.complete' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/complete.html',
            controller: 'ReportsCompleteController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.complete');
          }]
        }
      })
      .state('main.reports.analytic', {
        url: frontUrl + '/reports/analytic',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.analytic' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/analytic.html',
            controller: 'ReportsAnalyticController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.analytic');
          }],
          simpleObj: function () {
            return { reportType: 'default' };
          }
        }
      }).state('main.reports.daily-attendence', {
        url: frontUrl + '/reports/daily-attendences',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.dailyAttendences' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/daily-attendences.html',
            controller: 'ReportsDailyAttendencesController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.daily-attendences');
          }]
        }
      }).state('main.reports.analytic-mexico', {
        url: frontUrl + '/reports/analytic-mexico',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.analyticMexico' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/analytic.html',
            controller: 'ReportsAnalyticController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.analytic');
          }],
          simpleObj: function () {
            return { reportType: 'mexico' };
          }
        }
      }).state('main.reports.analytic-controldesk', {
        url: frontUrl + '/reports/analytic-controldesk',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.analyticControldesk' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/analytic.html',
            controller: 'ReportsAnalyticController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.analytic');
          }],
          simpleObj: function () {
            return { reportType: 'controlDesk' };
          }
        }
      }).state('main.reports.crm', {
        url: frontUrl + '/reports/crm',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.crm' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/crm.html',
            controller: 'ReportsCRMController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.crm');
          }]
        }
      }).state('main.reports.background-reports', {
        url: frontUrl + '/reports/background-reports',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.backgroundReports' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/background-reports.html',
            controller: 'BackgroundReportsController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.backgroundReports');
          }]
        }
      }).state('main.reports.productivity', {
        url: frontUrl + '/reports/productivity',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.productivity' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/productivity.html',
            controller: 'ReportsProductivityController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.prod');
          }]
        }
      }).state('main.reports.productivity-mexico', {
        url: frontUrl + '/reports/productivity-mexico',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.productivityMexico' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/productivity.html',
            controller: 'ReportsProductivityController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.prod');
          }]
        }
      })
      .state('main.reports.effectiviness', {
        url: frontUrl + '/reports/effectiviness',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.effectiviness' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/effectiviness.html',
            controller: 'ReportsEffectivinessController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.analytic');
          }]
        }
      })
      .state('main.reports.pause_control', {
        url: frontUrl + '/reports/pause-control',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.pauseControl' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/allowed-settings/reports/pause_control.html',
            controller: 'ReportsPauseControlController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.pause');
          }]
        }
      })
      .state('main.reports.badwordsReport', {
        url: frontUrl + '/reports/badwords-report',
        data: { pageTitle: 'Relatórios', role: 1, permission: 'reports.badWordFilter' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/allowed-settings/reports/badwords_report.html',
            controller: 'ReportsBadwordsConfigController as vm',
            resolve: {
              labels: ['$rootScope', function ($rootScope, LangService) {
                $rootScope.getPageLabels('menu.config.badwords');
              }]
            }
          }
        }
      })
      .state('main.reports.no_classification', {
        url: frontUrl + '/reports/no-classification',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.noClassification' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/no_classification.html',
            controller: 'ReportsNoClassificationController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.noclass');
          }]
        }
      })
      .state('main.reports.sms_received', {
        url: frontUrl + '/reports/sms-received',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.smsReceived' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/sms_received.html',
            controller: 'ReportsSMSReceivedController as vm'
          }
        }
      })
      .state('main.reports.click_sign', {
        url: frontUrl + '/reports/click-sign',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.clickSign' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/click_sign.html',
            controller: 'ReportsClickSignController as vm'
          }
        }
      })
      .state('main.reports.click_sign_errors', {
        url: frontUrl + '/reports/click-sign-errors',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.clickSignErrors' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/click_sign_errors.html',
            controller: 'ReportsClickSignErrorsController as vm'
          }
        }
      })
      .state('main.reports.tracker', {
        url: frontUrl + '/reports/tracker',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.tracker' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/tracker.html',
            controller: 'ReportsTrackerController as vm'
          }
        }
      })
      .state('main.reports.message_accounting', {
        url: frontUrl + '/reports/message-accounting',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.messageAccounting' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/message_accounting.html',
            controller: 'ReportsMessageAccountingController as vm'
          }
        }
      })
      .state('main.reports.customer_campaign_response', {
        url: frontUrl + '/reports/customer-campaign-response',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.customerCampaignResponse' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/customer_campaign_response.html',
            controller: 'ReportsCustomerCampaignResponseController as vm'
          }
        }
      })
      .state('main.reports.auto_history_classified', {
        url: frontUrl + '/reports/auto-history-classified',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.autoHistoryClassified' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/auto_history_classified.html',
            controller: 'ReportsAutoHistoryClassifiedController as vm'
          }
        }
      })
      .state('main.reports.auto_ai_classification', {
        url: frontUrl + '/reports/auto-ai-classification',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.autoAiClassification' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/auto_ai_classification.html',
            controller: 'ReportsAutoAIClassificationController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.auto_ai_classification');
          }]
        }
      })
      .state('main.reports.chatbot_customer_journey', {
        url: frontUrl + '/reports/chatbot-customer-journey',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.chatbotCustomerJourney' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/chatbot_customer_journey.html',
            controller: 'ReportsChatbotCustomerJourneyController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.chatbot_customer_journey');
          }]
        }
      })
      .state('main.reports.telesaqueb2b-transactions', {
        url: frontUrl + '/reports/telesaqueb2b-transactions',
        data: { pageTitle: 'Relatórios', role: 1, permission: 'reports.telesaqueB2bTransactions' },
        views: {
            '@main': { // viewName@stateName
                templateUrl: baseUrl + '/templates/reports/telesaqueb2b_transactions.html',
                controller: 'ReportTeleSaqueB2BTransactionController as vm'
            }
        },
        resolve: {
            labels: ['$rootScope', function($rootScope, LangService) {
                $rootScope.getPageLabels('menu.reports.telesaqueb2b_transactions');
            }]
        }
      })
      .state('main.reports.payrollv2-transactions', {
        url: frontUrl + '/reports/payrollv2-transactions',
        data: { pageTitle: 'Relatórios', role: 1, permission: 'reports.payrollV2Transactions' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/payrollv2_transactions.html',
            controller: 'ReportPayrollV2TransactionController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.payrollv2_transactions');
          }]
        }
      })
      .state('main.reports.customer-satisfaction-survey', {
        url: frontUrl + '/reports/customer-satisfaction-survey',
        data: { pageTitle: 'Relatórios', role: 1, permission: 'reports.customerSatisfactionSurvey' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/customer-satisfaction-survey.html',
            controller: 'CustomerSatisfactionSurveyController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.payrollv2_transactions');
          }]
        }
      })
      .state('main.reports.in100-transactions', {
        url: frontUrl + '/reports/in100-transactions',
        data: { pageTitle: 'Relatórios', role: 1 },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/in100_transactions.html',
            controller: 'ReportIn100TransactionsController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.in100-transactions');
          }]
        }
      })
      .state('main.attendance-identification', {
        url: frontUrl + '/security/attendance-identification',
        data: { pageTitle: 'Segurança', role: 1, permission: 'security.attendanceIdentification' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/security/attendance-identification.html',
            controller: 'AttendanceIdentificationController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.attendance-identification');
          }]
        }
      })
      .state('main.reports.chatbot_0800_digital', {
        url: frontUrl + '/reports/chatbot-0800-digital',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.chatbot0800Digital' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/chatbot_0800_digital.html',
            controller: 'ReportsChatbot0800DigitalController as vm'
          }
        }
      })
      .state('main.reports.time_per_operator', {
        url: frontUrl + '/reports/time-per-operator',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.timePerOperator' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/time_per_operator.html',
            controller: 'ReportsTimePerOperatorController as vm'
          }
        }
      })
      .state('main.reports.financial', {
        url: frontUrl + '/reports/financial',
        data: { pageTitle: 'Relatórios', role: 1000, permission: 'lord' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/financial.html',
            controller: 'ReportsFinancialController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.prod');
          }]
        }
      })
      .state('main.reports.financialConfference', {
        url: frontUrl + '/reports/financialConfference',
        data: { pageTitle: 'Relatórios', role: 1000, permission: 'lord' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/financialConfference.html',
            controller: 'ReportsFinancialConfferenceController as vm'
          }
        }
      })
      .state('main.reports.session_control', {
        url: frontUrl + '/reports/session-control',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.sessionControl' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/session_control.html',
            controller: 'ReportsSessionControlController as vm'
          }
        },
        resolve: {
          labels: resolveLabels('menu.reports.sessionControl')
        }
      })
      .state('main.reports.transaction_acoounting', {
        url: frontUrl + '/reports/transaction-accounting',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.transactionAccounting' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/transaction_accounting.html',
            controller: 'ReportsTransactionAccountingController as vm'
          }
        }
      })
      .state('main.reports.user_events', {
        url: frontUrl + '/reports/user-events',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.userEvents' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/user-events.html',
            controller: 'ReportsUserEventsController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.userEvents');
          }]
        }
      })
      .state('main.reports.digital_signature', {
        url: frontUrl + '/reports/digital-signature',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.digitalSignature' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/digital_signature.html',
            controller: 'ReportsDigitalSignatureController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.digitalSignature');
          }],
          simpleObj: function () {
            return { reportType: 'digital-signature' };
          }
        }
      })
      .state('main.reports.digital_signature_b2b', {
        url: frontUrl + '/reports/digital-signature-b2b',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.digitalSignatureB2b' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/digital_signature.html',
            controller: 'ReportsDigitalSignatureController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.digitalSignature')
          }],
          simpleObj: function () {
            return { reportType: 'digital-signature-b2b' }
          }
        }
      })
      .state('main.reports.active', {
        url: frontUrl + '/reports/active',
        data: { pageTitle: 'Relatórios', role: 0, permission: 'reports.activeReports' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/active.html',
            controller: 'ReportsActiveLogController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.active')
          }]
        }
      })
      .state('main.reports.insurance', {
        url: frontUrl + '/reports/insurance',
        data: { pageTitle: 'Relatórios', role: 0 },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/insurance.html',
            controller: 'ReportsInsuranceController as vmInsurance'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.insurance')
          }]
        }
      })
      .state('main.breakdown', {
        url: frontUrl + '/breakdown',
        data: { pageTitle: 'Pane', role: 0 },
        // , templateUrl: baseUrl + "/templates/admin/reports_contacts.html"
        templateUrl: baseUrl + '/templates/breakdown/breakdown.html',
        controller: 'BreakdownController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.config.pane');
          }]
        }
      })
      .state('main.monitor', {
        url: frontUrl + '/monitor',
        data: { pageTitle: 'Monitor', role: 0, permission: 'lord' },
        templateUrl: baseUrl + '/templates/monitor/monitor.html',
        controller: 'MonitorController as vm'
      })
      .state('main.pocs', {
        url: frontUrl + '/pocs',
        data: { pageTitle: 'Pocs', role: 0 },
        templateUrl: baseUrl + '/templates/pocs/pocs.html',
        controller: 'PocsController as vm'
      })
      .state('main.numbers', {
        url: frontUrl + '/numbers',
        data: { pageTitle: 'Números', role: 0 },
        templateUrl: baseUrl + '/templates/numbers/numbers.html',
        controller: 'NumbersController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('numbers');
          }]
        }
      })
      .state('main.detail', {
        url: frontUrl + '/pocs/{id}',
        data: { pageTitle: 'Detalhe de Poc', role: 0 },
        templateUrl: baseUrl + '/templates/pocs/pocs-detail.html',
        controller: 'PocsDetailController as vm'
      })
      .state('main.companies', {
        url: frontUrl + '/companies-management',
        data: { pageTitle: 'Cadastros', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/company/companies-management.html',
        controller: 'CompaniesController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.newComp');
          }]
        }
      })
      .state('main.new-company', {
        url: frontUrl + '/companies-management/new',
        data: { pageTitle: 'Nova Empresa', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/company/companies-management-create.html',
        controller: 'CompaniesController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.newComp');
          }]
        }
      })
      .state('main.edit-company', {
        url: frontUrl + '/companies-management/:id',
        data: { pageTitle: 'Editar Empresa', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/company/companies-management-edit.html',
        controller: 'CompaniesEditController as vm'
      })
      .state('main.sms', {
        url: frontUrl + '/sms',
        data: { pageTitle: 'SMS', role: 0 },
        templateUrl: baseUrl + '/templates/sms/sistema.html'
      })
      .state('main.sms-admin', {
        url: frontUrl + '/sms-admin/:id',
        data: { pageTitle: 'Canal de SMS', role: 0, permission: 'channel.sms' },
        templateUrl: baseUrl + '/templates/sms/list.html',
        controller: 'SMSController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.channel.sms');
          }]
        }
      })
      .state('main.poc-cobranca', {
        url: frontUrl + '/poc-cobranca',
        data: { pageTitle: 'POC Cobrança', role: 0 },
        templateUrl: baseUrl + '/templates/pocs/poc-cobranca.html',
        controller: 'PocCobrancaController as vm'
      })
      .state('main.facebook', {
        url: frontUrl + '/facebook/{id}',
        data: { pageTitle: 'Facebook', role: 0, permission: 'channel.facebook' },
        templateUrl: baseUrl + '/templates/facebook/facebook.html',
        controller: 'FacebookController as vm',
        resolve: {
          fbInitialize: function () {
            window.fbAsyncInit = function () {
              FB.init({
                appId: appId,
                xfbml: true,
                version: 'v2.5'
              });
            };

            (function (d, s, id) {
              var js; var fjs = d.getElementsByTagName(s)[0];
              if (d.getElementById(id)) { return; }
              js = d.createElement(s); js.id = id;
              js.src = '//connect.facebook.net/en_US/sdk.js';
              fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));
            return window.fbAsyncInit();
          },
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.channel.facebook');
          }]
        }
      })
      .state('main.whatsapp', {
        url: frontUrl + '/whatsapp/{id}',
        data: { pageTitle: 'WhatsApp', role: 0, permission: 'channel.whatsapp' },
        templateUrl: baseUrl + '/templates/whatsapp/whatsapp.html',
        controller: 'WhatsAppController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.channel.wApp');
          }]
        }
      })
      .state('main.web-chat', {
        url: frontUrl + '/web-chat/{id}',
        data: { pageTitle: 'Webchat', role: 0, permission: 'channel.webChat' },
        templateUrl: baseUrl + '/templates/webchat/webchat.html',
        controller: 'WebChatController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.channel.wChat');
          }]
        }
      })
      .state('main.create-webchat', {
        url: frontUrl + '/create-webchat/:id?',
        data: { pageTitle: 'Novo Web Chat', role: 1 },
        templateUrl: baseUrl + '/templates/webchat/create_webchat.html',
        controller: 'WebChatController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.channel.wChat');
          }]
        }
      })
      .state('main.emails', {
        url: frontUrl + '/emails/{id}',
        data: { pageTitle: 'E-mails', role: 0, permission: 'channel.emails' },
        templateUrl: baseUrl + '/templates/email/emails.html',
        controller: 'EmailsController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.channel.email');
          }]
        }
      })
      .state('main.channels', {})
      .state('main.channels.waent', {
        url: frontUrl + '/channels/waent',
        data: { pageTitle: 'Whatsapp Enterprise', role: 0, permission: 'channel.waent' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/channels/waent.html',
            controller: 'ChannelsWaentController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.channel.waent');
          }]
        }

      })
      .state('main.automation', {
        url: frontUrl + '/automation',
        data: { pageTitle: 'Automação', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/company/automation.html',
        controller: 'AutomationController as vm'
      })
      .state('main.company-edit', {
        url: frontUrl + '/company/:id',
        data: { pageTitle: 'Gestão da Minha Empresa', role: 0, permission: 'settings.myCompany' },
        templateUrl: baseUrl + '/templates/company/company-edit.html',
        controller: 'CompanyEditController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.config.myCompany');
          }]
        }
      })

      .state('main.general-settings', {
        url: frontUrl + '/general-settings/settings',
        data: { pageTitle: 'Configuração da Minha Empresa', role: 0, permission: 'settings.generalSettings' },
        views: {
          '': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/settings.html'
            //, controller: "GeneralSettingsController as vmGeneralCtrl"
          },
          'root@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tabs.html',
            data: { isAtendimento: false },
            controller: 'GeneralSettingsController as vmGeneralCtrl'
          },
          'notifications@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-notifications.html',
            controller: 'SettingsController as vmSettingsCtrl'
          },
          'control_pause@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-control-pause.html',
            controller: 'ControlPauseController as vmControlPauseCtrl'
          },
          'card_settings@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-card-settings.html',
            controller: 'CardSettingsController as vmCardSettingsCtrl'
          },
          'dashboard_settings@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-dashboard-settings.html',
            controller: 'DashboardSettingsController as vmDashboard'
          },
          'security@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-security.html',
            controller: 'SecurityController as vmSecurity'
          },
          'activeSender@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-active-sender.html',
            controller: 'ActiveSenderController as vmActiveCtrl'
          },
          'notificationsTracker@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-notifications-tracker.html',
            controller: 'NotificationsTrackerSettingsController as vmNotificationsTrackerSettingsCtrl'
          },
          'cp_settings@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-cp-settings.html',
            controller: 'CpSettingsController as vmCpSettingsCtrl'
          },
          'read_unread@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-read-unread.html',
            controller: 'ReadUnreadController as vmReadUnreadCtrl'
          },
          'campaign@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-campaign.html',
            controller: 'CampaignSettingsController as vmCampaignCtrl'
          },
          'custom_documents@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-custom-documents.html',
            controller: 'CustomDocumentsSettingsController as vmCustomDocumentsCtrl'
          },
          'formalizationProposalStatus@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-formalization-proposal-status.html',
            controller: 'FormalizationProposalStatusSettingsController as vmFormalizationProposalStatusCtrl'
          },
          'messagesPortal@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-messages-portal.html',
            controller: 'MessagesPortalSettingsController as vmMessagesPortalCtrl'
          },
          'login_settings@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-login-settings.html',
            controller: 'LoginSettingsController as vmLoginCtrl'
          },
          'exclusive_actions@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-exclusive-actions.html',
            controller: 'ExclusiveActionsController as vmExclusiveCtrl'
          },
          'automatic_answers@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-automatic-answers.html',
            controller: 'AutomaticAnswersTabController as vmAutomaticAnswersTab'
          },
          'knowledge_base@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-knowledge-base.html',
            controller: 'KnowledgeBaseSettingsController as vmKnowledgeBaseCtrl'
          },
          'history_settings@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-history-settings.html',
            controller: 'HistorySettingsController as vmHistorySettingsCtrl'

          },
          'formalization@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-formalization.html',
            controller: 'FormalizationSettingsController as vmFormalizationCtrl'
          },
          'supported_medias@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-supported-medias.html',
            controller: 'SupportedMediasController as vmSupportedMediasCtrl'
          },
          'company_employer@main.general-settings': {
            templateUrl: baseUrl + '/templates/general-settings/tab-company-employer.html',
            controller: 'ShowCompanyEmployerController as vmShowCECtrl'
          },
          'partner_companies@main.general-settings': {
            templateUrl: baseUrl + '/templates/general-settings/tab-partner-companies.html',
            controller: 'ShowPartnerCompaniesController as vmShowPartnerCompaniesCtrl'
          },
          'nps_survey@main.general-settings': {
            templateUrl: baseUrl + '/templates/general-settings/tab-nps-survey.html',
            controller: 'NpsSurveyController as vmNpsSurveyCtrl'
          },
          'company_insurance@main.general-settings': { // viewName@stateName
            templateUrl: baseUrl + '/templates/general-settings/tab-company-insurance.html',
            controller: 'ShowCompanyInsuranceController as vmShowInsuranceCtrl'
          },
          'b2b_telesaque_sending_proposal@main.general-settings': { // viewName@stateName
              templateUrl: baseUrl + '/templates/general-settings/tab-telesaque-b2b-sending-proposal.html',
              controller: 'TelesaqueB2bSendingProposalController as vmTelesaqueB2bSendingProposalCtrl'
          }
        },
        resolve: {

          labels: ['$rootScope', 'LangService', function ($rootScope, LangService) {
            LangService
              .getPageLabels({ 'page': 'menu.config.genSettings' })
              .$promise
              .then(function (data) {
                $rootScope.settings = { 'labels': data.lang };
              });
          }]
        }
      })

      .state('main.user-in-pause', {
        url: frontUrl + '/user-in-pause/paused',
        data: { pageTitle: 'Usuário Pausado', role: 0 },
        templateUrl: baseUrl + '/templates/user-paused/user-paused.html',
        controller: 'UserPausedController as vmUserPauseCtrl'
      })
      .state('main.mailingcampaign', {
        url: frontUrl + '/mailingcampaign',
        data: { pageTitle: 'Campanhas de Mailing', role: 0, permission: 'settings.mailingCampaign' },
        templateUrl: baseUrl + '/templates/mailingcampaign/mailingcampaign.html',
        controller: 'MailingCampaignsController as vm'
      })
      .state('main.mailingcampaignconfigs', {
        url: frontUrl + '/mailingcampaign/configs',
        data: { pageTitle: 'Campanhas de Mailing', role: 0 },
        templateUrl: baseUrl + '/templates/mailingcampaign/mailingcampaign-configs.html',
        controller: 'MailingCampaignsConfigsController as vm'
      })
      .state('main.mailingcampaigntags', {
        url: frontUrl + '/mailingcampaign/tags',
        data: { pageTitle: 'Campanhas de Mailing', role: 0 },
        templateUrl: baseUrl + '/templates/mailingcampaign/mailingcampaign-tags.html',
        controller: 'MailingCampaignsTagsController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.config.mailingtags');
          }]
        }
      })
      .state('main.mailingprocessedfiles', {
        url: frontUrl + '/processedfiles',
        data: { pageTitle: 'Arquivos processados', role: 0 },
        templateUrl: baseUrl + '/templates/mailingcampaign/processedfiles.html',
        controller: 'MailingCampaignsController as vm'
      })
      .state('main.new-mailingcampaign', {
        url: frontUrl + '/mailingcampaign/create',
        data: { pageTitle: 'Campanhas de Mailing - Novo', role: 0 },
        templateUrl: baseUrl + '/templates/mailingcampaign/mailingcampaign-create.html',
        controller: 'MailingCampaignsController as vm'
      })
      .state('main.upload-mailingcampaign', {
        url: frontUrl + '/mailingcampaign/upload',
        data: { pageTitle: 'Campanhas de Mailing - Upload', role: 0 },
        templateUrl: baseUrl + '/templates/mailingcampaign/mailingcampaign-upload.html',
        controller: 'MailingCampaignsController as vm'
      })
      .state('main.edit-mailingcampaign', {
        url: frontUrl + '/mailingcampaign/:id',
        data: { pageTitle: 'Campanhas de Mailing - Edição', role: 0 },
        templateUrl: baseUrl + '/templates/mailingcampaign/mailingcampaign-create.html',
        controller: 'MailingCampaignsController as vm'
      })
      .state('main.campaign', {
        url: frontUrl + '/campaign',
        data: { pageTitle: 'Envio Rápido', role: 0 },
        templateUrl: baseUrl + '/templates/campaign/campaign.html',
        controller: 'CampaignController as vm'
      })
      .state('main.campaign-create', {
        url: frontUrl + '/campaign/create',
        data: { pageTitle: 'Envio Rápido - Novo', role: 0 },
        templateUrl: baseUrl + '/templates/campaign/campaign-create.html',
        controller: 'CampaignCreateController as vm'
      })
      .state('main.knowledgebase', {
        url: frontUrl + '/knowledge-base',
        data: { pageTitle: 'Perguntas e Respostas', role: 0 },
        templateUrl: baseUrl + '/templates/knowledgebase/knowledge-base.html',
        controller: 'KnowledgeBaseController as vm'
      })
      .state('main.notification-tracker', {
        url: frontUrl + '/notifications-tracker',
        data: { pageTitle: 'Esteira de notificações', role: 0 },
        templateUrl: baseUrl + '/templates/notification-tracker/notification-tracker.html',
        controller: 'NotificationTrackerStatusController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.config.notificationTracker');
          }]
        }
      })
      .state('main.custom-documents', {
        url: frontUrl + '/custom-documents',
        data: { pageTitle: 'Documentos personalizados', role: 0 },
        templateUrl: baseUrl + '/templates/custom-documents/custom-documents.html',
        controller: 'CustomDocumentsController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.config.customDocuments');
          }]
        }
      })
      .state('main.reports.mailing-general', {
        url: frontUrl + '/reports/mailing/general',
        data: { pageTitle: 'Relatórios', role: 0 },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/mailing-general.html',
            controller: 'ReportsMailingGeneralController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.reports.mailing.gen');
          }]
        }
      })
      .state('main.reports.mailing-specific', {
        url: frontUrl + '/reports/mailing/specific',
        data: { pageTitle: 'Relatórios', role: 0 },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/mailing-specific.html',
            controller: 'ReportsMailingSpecificController as vm'
          }
        }
      })
      .state('main.reports.campaign-general', {
        url: frontUrl + '/reports/campaign/general',
        data: { pageTitle: 'Relatórios', role: 0 },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/campaign-general.html',
            controller: 'ReportsCampaignGeneralController as vm'
          }
        }
      })
      .state('main.reports.campaign-specific', {
        url: frontUrl + '/reports/campaign/specific',
        data: { pageTitle: 'Relatórios', role: 0 },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/reports/campaign-specific.html',
            controller: 'ReportsCampaignSpecificController as vm'
          }
        }
      })
      .state('logout', {
        url: frontUrl + '/logout',
        data: { pageTitle: 'Logout' },
        controller: 'LogoutController as vm'
      })
      .state('main.automatic-distribution', {
        url: frontUrl + '/rules/attendances/automatic-distribution',
        data: { pageTitle: 'Distribuição Automática', role: 1000, permission: 'lord' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/automatic-distribution/rules.html',
            controller: 'AutomaticDistributionController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.busRules.autDistr');
          }]
        }
      })
      .state('main.attendances', {
        url: frontUrl + '/rules/attendances',
        data: { pageTitle: 'Regras de atendimento', role: 1000, permission: 'lord' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/attendances/rules.html',
            controller: 'AttendanceRulesController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.busRules.att');
          }]
        }
      })
      .state('main.cp-status', {
        url: frontUrl + '/cp-status',
        data: { pageTitle: 'Status Command-Processor', role: 0 },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/cp-status/cp-status.html',
            controller: 'CPStatusController as vmCPStatusCtrl'
          }
        }
      })
      .state('main.formalization-proposal-status', {
        url: frontUrl + '/formalization-proposal-status',
        data: { pageTitle: 'Status das propostas de formalização', role: 0 },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/formalization-proposal-status/formalization-proposal-status.html',
            controller: 'FormalizationProposalStatusController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.config.formalizationProposalStatus');
          }]
        }
      })
      .state('main.channels-plugin', {})
      .state('main.channels-plugin.chatbots', {
        url: frontUrl + '/channels-plugin/chatbots',
        data: { pageTitle: 'Chatbots', role: 1000, permission: 'lord' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/channels-plugin/chatbots.html',
            controller: 'ChatbotController as vm'
          }
        }
      })
      .state('main.channels-plugin.message-webhook', {
        url: frontUrl + '/channels-plugin/message-webhook',
        data: { pageTitle: 'Webhooks de Mensagem', role: 1000, permission: 'lord' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/channels-plugin/message-webhook.html',
            controller: 'MessageWebhookController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.channelsPlugin.messageWebhook');
          }]
        }
      })
      .state('main.channels-plugin.handle-attendance', {
        url: frontUrl + '/channels-plugin/handle-attendance',
        data: { pageTitle: 'Alterar cards', role: 1000, permission: 'lord' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/channels-plugin/handle-attendance.html',
            controller: 'HandleAttendanceController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.channelsPlugin.handleAttendance');
          }]
        }
      })
      .state('main.channels-plugin.white-list', {
        url: frontUrl + '/channels-plugin/white-list',
        data: { pageTitle: 'White List', role: 0, permission: 'lord' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/channels-plugin/white-list.html',
            controller: 'WhiteListController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.channelsPlugin.whiteList');
          }]
        }
      })
      .state('main.channels-plugin.nac-white-list', {
        url: frontUrl + '/channels-plugin/nac-white-list',
        data: { pageTitle: 'NAC White List', role: 1, permission: 'channelPlugins.nacWhiteList' },
        views: {
          '@main': { // viewName@stateName
            templateUrl: baseUrl + '/templates/channels-plugin/nac-white-list.html',
            controller: 'NacWhiteListController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.channelsPlugin.nacWhiteList');
          }]
        }
      })
      .state('main.channels-plugin.hsm', {
        url: frontUrl + '/channels-plugin/hsm',
        data: { pageTitle: 'HSM', role: 0 },
        views: {
          '@main': {
            templateUrl: baseUrl + '/templates/channels-plugin/hsm.html',
            controller: 'HsmController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.channelsPlugin.hsm');
          }]
        }
      })

      .state('main.channels-plugin.company-employer', {
        url: frontUrl + '/channels-plugin/company-employer',
        data: { pageTitle: 'Cadastro Empresa/Empregador', role: 0 },
        views: {
          '@main': {
            templateUrl: baseUrl + '/templates/channels-plugin/company-employer.html',
            controller: 'CompanyEmployerController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.channelsPlugin.companyEmployer');
          }]
        }
      })

      .state('main.risk-list', {
        url: frontUrl + '/risk-list',
        data: { pageTitle: 'Lista de Risco', role: 1, permission: 'lord' },
        templateUrl: baseUrl + '/templates/channels-plugin/risk-list.html',
        controller: 'RiskListController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.riskList');
          }]
        }
      })

      .state('main.control-list', {
        url: frontUrl + '/control-list',
        data: { pageTitle: 'Controle de Listas', role: 1000, permission: 'security.controlList' },
        templateUrl: baseUrl + '/templates/channels-plugin/control-list.html',
        controller: 'ControlListController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.master.controlList');
          }]
        }
      })

      .state('main.campaign-management', {
        url: frontUrl + '/campaign-management',
        data: { pageTitle: 'Gerenciamento de Campanhas', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/campaign-management/campaign-management.html',
        controller: 'CampaignManagementController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.campaign');
          }]
        }
      })

      .state('main.campaign-management-create', {
        url: frontUrl + '/campaign-management-create',
        data: { pageTitle: 'Nova Campanha', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/campaign-management/campaign-management-form.html',
        controller: 'CampaignManagementFormController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.campaign');
          }]
        }
      })

      .state('main.campaign-management-edit', {
        url: frontUrl + '/campaign-management-edit/:id',
        data: { pageTitle: 'Editar campanha', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/campaign-management/campaign-management-form.html',
        controller: 'CampaignManagementFormController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.campaign');
          }]
        }
      })

      .state('main.campaign-broadcast', {
        url: frontUrl + '/campaign-broadcast',
        data: { pageTitle: 'Transmissão de Campanhas', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/campaign-broadcast/campaign-broadcast.html',
        controller: 'CampaignBroadcastController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.campaign.broadcast');
          }]
        }
      })

      .state('main.exthub-configs', {
        url: frontUrl + '/exthub-configs',
        data: { pageTitle: 'Configurações', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/exthub-configs/exthub-configs.html',
        controller: 'ExthubConfigsController as vm'
      })
      .state('main.langs', {
        url: frontUrl + '/langs',
        data: { pageTitle: 'Langs', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/langs/lang.html',
        controller: 'LangController as vm'
      })
      .state('main.chatbot-messages', {
        url: frontUrl + '/chatbot-messages',
        data: { pageTitle: 'Mensagens dos ChatBots', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/chatbot/chatbot-messages.html',
        controller: 'ChatBotMessagesController as vm'
      })
      .state('main.chatbot-configs', {
        url: frontUrl + '/chatbot-configs',
        data: { pageTitle: 'Configurações dos ChatBots', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/chatbot/chatbot-configs.html',
        controller: 'ChatBotConfigsController as vm'
      })
      .state('main.auto-reports', {
        url: frontUrl + '/auto-reports',
        data: { pageTitle: 'AutoReports', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/auto-reports/auto-report.html',
        controller: 'AutoReportController as vm'
      })
      .state('main.track-notification', {
        url: frontUrl + '/track-notification',
        data: { pageTitle: 'Tracker - Json', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/track-notification/track-notification.html',
        controller: 'TrackNotificationController as vm'
      }).state('main.fix-cards', {
        url: frontUrl + '/fix-cards',
        data: { pageTitle: 'Fix Cards', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/fix-cards/fix-cards.html',
        controller: 'FixCardsController as vm'
      })
      .state('main.contact-metadata-definition', {
        url: frontUrl + '/contact-metadata-definition',
        data: { pageTitle: 'Contact Metadata', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/contact-metadata-definition/contact-metadata-definition.html',
        controller: 'ContactMetadataDefinitionController as vm'
      })
      .state('main.messages-portal-create', {
        url: frontUrl + '/messages-portal/templates-create',
        data: { pageTitle: 'Portal de Envio - Cadastro de Mensagens', role: 0 },
        templateUrl: baseUrl + '/templates/messages-portal/messages-portal-template-create.html',
        controller: 'MessagesPortalTemplateCreateController as vm',
        params: {
          id: null
        }
      })
      .state('main.messages-portal-overview', {
        url: frontUrl + '/messages-portal/templates-overview',
        data: { pageTitle: 'Portal de Envio - Mensagens', role: 0, page: 'messages-portal-template' },
        templateUrl: baseUrl + '/templates/messages-portal/messages-portal-template-overview.html',
        controller: 'MessagesPortalTemplateOverviewController as vm'
      })
      .state('main.messages-portal-send', {
        url: frontUrl + '/messages-portal/send',
        data: { pageTitle: 'Portal de Envio', role: 0, page: 'messages-portal-send' },
        templateUrl: baseUrl + '/templates/messages-portal/messages-portal-send.html',
        controller: 'MessagesPortalController as vm'
      })
      .state('main.send-proposal-telesaque', {
        url: frontUrl + '/messages-portal/send-proposal-telesaque',
        data: { pageTitle: 'Envio de ativo Telesaque B2B', role: 2, page: 'send-proposal-telesaque' },
        templateUrl: baseUrl + '/templates/messages-portal/send-proposal-telesaque.html',
        controller: 'SendProposalTelesaqueController as vm'
      })
      .state('main.messages-portal-report', {
        url: frontUrl + '/messages-portal/report',
        data: { pageTitle: 'Relatório Portal de Envios', role: 0, page: 'messages-portal-report' },
        templateUrl: baseUrl + '/templates/messages-portal/messages-portal-report.html',
        controller: 'MessagesPortalReportController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.messagesPortal.messagesReport');
          }]
        }
      })
      .state('main.messages-portal-history', {
        url: frontUrl + '/messages-portal/history',
        data: { pageTitle: 'Portal de Envio - Histório', role: 0, page: 'messages-portal-history' },
        templateUrl: baseUrl + '/templates/messages-portal/messages-portal-history.html',
        controller: 'MessagesPortalHistoryController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.messagesPortal.history');
          }]
        }
      })
      .state('main.jobs', {
        url: frontUrl + '/jobs',
        data: { pageTitle: 'Jobs', role: 1000, permission: 'lord' },
        views: {
          '': { // viewName@stateName
            templateUrl: baseUrl + '/templates/jobs/index.html'
          },
          'root@main.jobs': { // viewName@stateName
            templateUrl: baseUrl + '/templates/jobs/tabs.html',
            controller: 'JobsController as vm'
          },
          'workers@main.jobs': { // viewName@stateName
            templateUrl: baseUrl + '/templates/jobs/tab-workers.html',
            controller: 'JobsWorkerController as vm'
          }
        },
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.master.jobs');
          }]
        }
      })
      .state('main.jobs-queue', {
        url: frontUrl + '/jobs-queue',
        data: { pageTitle: 'Jobs Queue', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/jobs-queue/jobs-queue.html',
        controller: 'JobsQueueController as vmJobsQueueCtrl'
      })
      .state('main.register-webhook', {
        url: frontUrl + '/register-webhook',
        data: { pageTitle: 'Register Webhook', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/webhook/register-webhook.html',
        controller: 'RegisterWebhookController as vm'
      })
      .state('main.attendance-counter', {
        url: frontUrl + '/attendance-counter',
        data: { pageTitle: 'Attendance Counter', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/attendance-counter/attendance-counter.html',
        controller: 'AttendanceCounterController as vm'
      })
      .state('main.country', {
        url: frontUrl + '/country',
        data: { pageTitle: 'Country', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/country/country.html',
        controller: 'CountryController as vm'
      })
      .state('main.event', {
        url: frontUrl + '/event',
        data: { pageTitle: 'Events', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/event/event.html',
        controller: 'EventController as vm'
      })
      .state('main.integrations-configs', {
        url: frontUrl + '/integrations-configs',
        data: { pageTitle: 'Configurações de integrações', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/integrations/configs.html',
        controller: 'IntegrationsConfigsController as vm'
      })
      .state('main.digital-signature-contracts', {
        url: frontUrl + '/digital-signature/contracts',
        data: { pageTitle: 'Assinatura Digital', role: 0 },
        templateUrl: baseUrl + '/templates/digital-signature/digital-signature.html',
        controller: 'DigitalSignatureController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope) {
            $rootScope.getPageLabels('menu.digitalSignature.contracts');
          }]
        }
      })
      .state('main.register-pdvs', {
        url: frontUrl + '/register-pdvs',
        data: { pageTitle: 'Cadastro PDVs', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/pdv/pdv.html',
        controller: 'PdvController as vm'
      })
      .state('main.email-batch', {
        url: frontUrl + '/email-batch',
        data: { pageTitle: 'Lotes de E-mail', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/email-batch/email-batch.html',
        controller: 'EmailBatchController as vm'
      })
      .state('main.profile-permission-control', {
        url: frontUrl + '/profile-permission-control',
        data: { pageTitle: 'Permissoes', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/permissions/profile-permission-control.html',
        controller: 'ProfilePermissionControlController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.master.permission');
          }]
        }
      })
      .state("main.lord-configs", {
        url: frontUrl + "/lord-configs"
        , data: { pageTitle: "Configurações de Lord", role: 1000, permission: 'lord' }
        , templateUrl: baseUrl + "/templates/lord/configs.html"
        , controller: 'LordConfigsController as vm'
      })
      .state('main.insurance', {
        url: frontUrl + '/insurance'
        , data: { pageTitle: 'Seguros', role: 0 }
        , templateUrl: baseUrl + '/templates/insurance/form-web.html'
        , controller: 'InsuranceController as vm'
        , resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.insurance.form-web');
          }]
        }
      })
      .state('main.insurance-error-info', {
        url: frontUrl + '/insurance-error-info'
        , data: { pageTitle: 'Informações de Erro', role: 1000, permission: 'lord' }
        , templateUrl: baseUrl + '/templates/insurance-error-info/insurance-error-info.html'
        , controller: 'InsuranceErrorInfoController as vm'
        , resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.insurance.insurance-error-info');
          }]
        }        
      })
      .state('main.mass-user', {
        url: frontUrl + '/mass-user',
        data: { pageTitle: 'Usuários em Massa', role: 1000, permission: 'security.massUser' },
        templateUrl: baseUrl + '/templates/mass-user/mass-user.html',
        controller: 'MassUserController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.master.mass-user');
          }]
        }
      })
      .state("main.badwords-config", {
        url: frontUrl + "/badwords-config"
        , data: { pageTitle: "Configurações de Palavras Impróprias", role: 1000, permission: 'lord' }
        , templateUrl: baseUrl + "/templates/badwords-config/badwords-config.html"
        , controller: 'BadwordsConfigController as vm'
        , resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.config.badwords');
          }]
        }
      })
      .state('main.list-control', {
        url: frontUrl + '/list-control',
        data: { pageTitle: 'List Control', role: 1000, permission: 'lord' },
        templateUrl: baseUrl + '/templates/list-control/list-control.html',
        controller: 'ListControlController as vm',
        resolve: {
          labels: ['$rootScope', function ($rootScope, LangService) {
            $rootScope.getPageLabels('menu.master.list-control');
          }]
        }
      })

    $urlRouterProvider.otherwise(frontUrl + '/atendimento');
    $locationProvider.html5Mode(true);
  }

  run.$inject = ['$rootScope', 'LangService', '$http', '$state', '$stateParams', 'ControlPauseService', 'LocalStorageService', 'socketConnect', 'PasswordValidationService', 'PermissionControlService'];

  function run($rootScope, LangService, $http, $state, $stateParams, ControlPauseService, LocalStorageService, socketConnect, PasswordValidationService, PermissionControlService) {
    FastClick.attach(document.body);
    $rootScope.changeUserCurrentCompany = function () {
      var user = $rootScope.user_data;

      $http.patch(apiUrl + '/change-company', {
        company_id: user.company_id_filter
      }).then(function (response) {
        $stateParams['id'] = user.company_id_filter;
        $state.reload();
      }, function (error) { console.log(error) });
    };

    $rootScope.clearFilterSelectedCompany = function () {
      $rootScope.user_data.company_name_filter = "";
      $rootScope.user_data.showCompanyList = true;
    };

    $rootScope.checkMenuAccess = function (name = "") {
      return PermissionControlService.checkAllowed(name);
    }

    $rootScope.passwordStrengthMonitor = function (password) {
      let progressBar = angular.element(document.querySelector('.progress-bar'))[0];
      PasswordValidationService.validatePasswordsStrength(password, progressBar);
    }

    $rootScope.getPageLabels = function (page, callback) {
      return LangService
        .getPageLabels({ 'page': page })
        .$promise
        .then(function (data) {
          $rootScope.labels = data.lang;
          if (angular.isFunction(callback)) {
            callback();
          }
        })
    };

    $rootScope.setPause = function () {
      ControlPauseService
        .create({ reason_id: null })
        .$promise
        .then(function (data) {
          var ModelFactory = { is_paused: data.is_paused, start_pause_at: data.start_pause_at };
          if (data.hasOwnProperty('auto_logout_at') && data.auto_logout_at != null) {
            ModelFactory.auto_logout_at = data.auto_logout_at;
          }
          LocalStorageService.saveUserPauseState(ModelFactory);
          LocalStorageService.sendToBlockPage();
          $rootScope.user_data.session_user.is_paused = true;
          $rootScope.user_data.operator_status = false;
        })
        .catch();
    };

    $rootScope.selectResult = function (company) {
      $rootScope.user_data.company_id_filter = company.id;
      $rootScope.user_data.company_name_filter = company.name;
      $rootScope.user_data.showCompanyList = false;
    };

    $rootScope.refreshCompanyNameFilter = function () {
      $rootScope.user_data.company_id_filter = $rootScope.user_data.company_id;
      $rootScope.user_data.company_name_filter = $rootScope.user_data.company_name;
      $rootScope.user_data.showCompanyList = false;
    };

    $rootScope.allowedRoles = function (rolesArray) {
      var currentRole = $rootScope.user_data.role;
      if (rolesArray.indexOf(currentRole) == -1) {
        return false;
      }
      return true;
    };
  }

  title.$inject = ['$rootScope', '$timeout'];
  function title($rootScope, $timeout) {
    return {
      link: function () {
        var listener = function (event, toState) {
          $timeout(function () {
            $rootScope.isAtendimento = (toState.data && toState.data.isAtendimento)
              ? toState.data.isAtendimento : false;

            $rootScope.title = (toState.data && toState.data.pageTitle)
              ? toState.data.pageTitle + ' :: ' + (page_title || '')
              : (page_title || '');

            $rootScope.rawTitle = (toState.data && toState.data.pageTitle)
              ? toState.data.pageTitle
              : (page_title || '');
          });
        };

        $rootScope.$on('$stateChangeSuccess', listener);
      }
    };
  }

  uploadDiretive.$inject = [];
  function uploadDiretive() {
    return {
      restrict: 'E',
      require: 'ngModel',
      replace: true,
      scope: {
        files: '=ngModel',
        uploadFiles: '&uploadFiles',
        nwFileErrors: '=nwFileErrors'
      },
      link: function (scope, element, attrs) {
        // SELECIONA OS ARQUIVOS NO HTML
        scope.selectFiles = function (file) {
          if (file !== undefined) {
            if (file) {
              if (angular.isArray(file)) {
                angular.forEach(file, function (elem, i) {
                  scope.files = elem;
                })
              }
            }
          }
        }
        // VALIDA OS ARQUIVOS PARA VERIFICAR SE FOI COLOCADO UM NOME PARA PODER ENVIAR PRO CONTROLLER
        scope.validate = function () {
          scope.uploadFiles(scope.files);
        }
        // REMOVER O ARQUIVO DO ARRAY
        scope.removerArquivo = function (index) {
          scope.files.splice(index, 1);
        }
      },

      templateUrl: frontUrl + '/templates/common/arquivos.html'
    };
  }

  angular.module('MktzapApp.Controllers', ['Common'])
    .filter('log', function () {
      return function (val) {
        return '';
      };
    })
    .filter('display_phone_brasil', function () {
      return function (input) {
        if (input != void 0) {
          var str = '';

          // Brasil
          if (input.length == 11 || input.length == 10) {
            // Ninth digit
            str = input.substr(0, 2);
            str += ' ';
            str += input.substr(2);
          } else {
            str = input.substr(2, 2);
            str += ' ';
            str += input.substr(4);
          }
        }
        return str;
      }
    })
    .filter('display_phone', function () {
      return function (input) {
        if (input != void 0) {
          var str = '';
          if (input.substr(0, 2) == '55') {
            // Brasil
            if (input.length == 13) {
              // Ninth digit
              str = input.substr(2, 2);
              str += ' ';
              str += input.substr(4, 5);
              str += ' ';
              str += input.substr(9);
            } else if (input.length == 12) {
              // No ninth digit
              str = input.substr(2, 2);
              str += ' ';
              str += input.substr(4, 4);
              str += ' ';
              str += input.substr(8);
            } else {
              str = input.substr(2, 2);
              str += ' ';
              str += input.substr(4);
            }
          } else {
            // International
            str = '+' + input;
          }
          return str;
        }
      };
    })
    .filter('display_name_phone', function () {
      return function (input) {
        if (input != void 0) {
          if(input.match(/[0-9]{4}/) == null) return input;

          return input.replace(/([0-9]{3,4}$)/, 'XXXX');
        }
        return "";
      };
    })
    .filter('contact_id_display_phone', ['$filter', function ($filter) {
      return function (input) {
        if (input != void 0) {
          input = input.replace(new RegExp('(.+)_', 'g'), '');
          input = input.replace(new RegExp('(.+)_', 'g'), '');
          return $filter('display_phone')(input);
        }
        return '';
      };
    }])
    .filter('contact_id_display_email', function () {
      return function (input) {
        if (input != void 0) {
          input = input.replace(new RegExp('(.+)_', 'g'), '');
          return input;
        }
      };
    })
    .filter('history_metadata_display_email', ['$filter', function ($filter) {
      return function (history) {
        if (history != void 0) {
          var from = '';
          angular.forEach(history.metadata, function (val) {
            if (val.meta_key == 'from') {
              from = val.meta_value;
            }
          });
          if (from.length == 0) {
            from = $filter('contact_id_display_email')(history.contact_id);
          }
          return from;
        }
      };
    }])
    .filter('history_metadata_display_subject', ['$filter', function ($filter) {
      return function (history) {
        if (history != void 0) {
          var from = '';
          angular.forEach(history.metadata, function (val) {
            if (val.meta_key == 'clean_subject') {
              from = val.meta_value;
            }
          });
          if (from.length == 0) {
            from = $filter('contact_id_display_email')(history.contact_id);
          }
          return from;
        }
      };
    }])
    .filter('display_datetime', function ($rootScope) {
      return function (input) {
        if (input != void 0) {
          var str = moment.tz(input, 'YYYY-MM-DD HH:mm:ss', 'UTC').tz($rootScope.locale.timezone).format('DD/MM/YYYY HH:mm:ss');
          return str;
        }
      };
    })
    .filter('display_date', function () {
      return function (input) {
        if (input != void 0) {
          return moment(input, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
        }
      };
    })
    .filter('display_date_only', function ($rootScope) {
      return function (input) {
        if (input != void 0) {
          return moment.tz(input, 'YYYY-MM-DD HH:mm:ss', 'UTC').tz($rootScope.locale.timezone).format('DD/MM/YYYY');
        }
      };
    }).filter('display_hour_only', function ($rootScope) {
      return function (input) {
        if (input != void 0) {
          return moment.tz(input, 'YYYY-MM-DD HH:mm:ss', 'UTC').tz($rootScope.locale.timezone).format('HH:mm:ss');
        }
      };
    }).filter('display_datenotime_date_only', function () {
      return function (input) {
        if (input != void 0) {
          return moment(input, 'YYYY-MM-DD').format('DD/MM/YYYY');
        }
      };
    })
    .filter('date_user', function ($rootScope) {
      return function (input) {
        if (input != void 0) {
          var str = moment.tz(input, 'YYYY-MM-DD HH:mm:ss', 'UTC').tz($rootScope.locale.timezone).format('DD/MM/YYYY HH:mm:ss');
          return str;
        }
      };
    })
    .filter('capitalize', function () {
      return function (val) {
        if (typeof val !== 'undefined') {
          var letter = val.charAt(0)
          return val.replace(letter, letter.toLocaleUpperCase());
        }
      };
    })
    .filter('trusted', ['$sce', function ($sce) {
      return function (url) {
        return $sce.trustAsResourceUrl(url);
      };
    }]);
})();
